import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'estado',
    standalone: false
})
export class ProveedorEstadoPipe implements PipeTransform {
    transform(value) {
        return value ? 'Activo' : 'Inactivo';
    }
}
